<template>
    <ModalFormCard class="modal-default" :action="action">
        <template #title>Payment method</template>

        <template #default="{ saving, errors }">
            <!-- <p class="font-semibold text-18">{{ $help.capitalizeFirstLetter(card.brand) }} ending {{ card.last_4 }}</p> -->

            <!-- <div class="mt-7 flex w-full lg:flex-row flex-col">
                <div class="lg:border-r border-grey-500 lg:pr-[76px] flex-1">
                    <PaymentMethodCard class="w-full lg:w-[332px] shrink-0" :paymentMethod="card" />
                </div>

                <div class="flex flex-col items-center justify-center flex-1 text-13 lg:pl-10 pt-8 lg:pt-0 pb-7 lg:pb-0">
                    <button
                        type="button"
                        class="w-full lg:w-[150px] h-12 lg:h-10 border bg-black border-black text-black mb-3 font-semibold hover:outline-transition"
                        @click="edit = !edit"
                    >
                        {{ edit ? 'Cancel' : 'Update card' }}
                    </button>

                    <button
                        type="button"
                        class="w-full lg:w-[150px] h-12 lg:h-10 bg-black text-white mb-3 font-semibold hover:black-on-white"
                        @click="makeDefault"
                        :disabled="card.default_payment_method != null"
                    >
                        {{ card.default_payment_method != null ? 'Default card' : 'Make default' }}
                    </button>

                    <button
                        type="button"
                        class="w-full lg:w-[150px] h-12 lg:h-10 bg-purple-600 text-white font-semibold hover:black-on-white"
                        :disabled="card.default_payment_method != null"
                        @click="destroy"
                    >
                        Delete card
                    </button>
                </div>
            </div> -->

            <Input
                class="w-full"
                groupClass="bg-grey text-15"
                label="Cardholder name"
                placeholder="Enter cardholder name"
                name="name_on_card"
                v-model:value="value.name_on_card"
            />

            <div class="grid grid-cols-4 mt-4 gap-2">
                <Input
                    groupClass="bg-grey text-15"
                    label="Expiry month"
                    placeholder="Enter expiry month"
                    name="exp_month"
                    v-model:value="value.exp_month"
                />

                <Input
                    groupClass="bg-grey text-15"
                    label="Expiry year"
                    placeholder="Enter expiry year"
                    name="exp_year"
                    v-model:value="value.exp_year"
                />
            </div>

            <Input
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Address"
                placeholder="Address line 1"
                name="address_line_1"
                v-model:value="value.address_line_1"
                :hideError="true"
            />
            <Input
                class="mt-1"
                groupClass="bg-grey text-15"
                placeholder="Address line 2"
                name="address_line_2"
                v-model:value="value.address_line_2"
            />
            <Input class="mt-1" groupClass="bg-grey text-15" placeholder="Town or City" name="town" v-model:value="value.town" />
            <Input
                class="mt-1"
                groupClass="bg-grey text-15"
                placeholder="Post code"
                name="postcode"
                v-model:value="value.postcode"
                :hideError="true"
            />

            <Error v-if="errors" :error="errors.has('address_line_1')" />
            <Error v-if="errors" :error="errors.has('postcode')" />

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black default"> Update card </ButtonSaving>

                <button type="button" @click="$emit('close')" class="h-12 button-purple">Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import PaymentMethod from '~/models/payment-method.js'
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    created() {
        this.setup(PaymentMethod)
        this.card = this.editingModel
    },

    data() {
        return {
            edit: false,
            card: null,
        }
    },

    methods: {
        makeDefault() {
            this.$axios.put('/payment-method/' + this.editingModel.id).then((res) => {
                this.card = res
                this.$event.$emit('modal-form-completed')
            })
        },

        destroy() {
            this.$axios.delete('/payment-method/' + this.editingModel.id).then((res) => {
                this.$event.$emit('modal-form-completed')
                this.$emit('close')
            })
        },
    },
}
</script>
